import { HeadCogIcon } from './HeadCogIcon';

/**
 * author: Google
 * id 58C540DF-30BA-449B-8426-61AD2C43959D
 * name head-cog
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/head-cog.svg
 * tags
 * - Settings 
 */
export const PsychologyIcon = HeadCogIcon;
export default PsychologyIcon